import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../../../utils/API/responseMiddleware";
import { transformRequest } from "../../../../utils/API/requestMiddleware";

const EventFeedbackQuestionApi = createApi({
    reducerPath: 'EventFeedbackQuestionApi',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        getFeedbackQuestionEventDetailList: builder.mutation({
            query: (details) => ({
                url: '/EventManagement/GetFeedbackQuestionEventDetailList',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllFeedbackAnswerListByEventId: builder.query({
            query: (details) => ({
                url: `/EventManagement/GetAllFeedbackAnswerListByEventId?id=${details.eventId}`,
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

    }),
})
export const {
    useGetFeedbackQuestionEventDetailListMutation,
    useLazyGetAllFeedbackAnswerListByEventIdQuery
} = EventFeedbackQuestionApi;

export default EventFeedbackQuestionApi;